exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.create-btn[data-v-2f96db1e] {\n  text-align: right;\n  margin-bottom: 10px;\n}\n.tabs .tab-content .tab-pane[data-v-2f96db1e] {\n  padding: 0;\n}\n.users-tab[data-v-2f96db1e] {\n  color: white !important;\n}\n.users-tab.user[data-v-2f96db1e] {\n    background-color: #63c2de !important;\n}\n.users-tab.role[data-v-2f96db1e] {\n    background-color: #20a8d8 !important;\n}\n.users-tab.active[data-v-2f96db1e] {\n    color: inherit !important;\n    background-color: white !important;\n}\n.delete-warning[data-v-2f96db1e] {\n  font-size: 1rem;\n  color: red;\n}\n#users[data-v-2f96db1e] {\n  color: black;\n}\n#users[data-v-2f96db1e]:hover {\n  text-decoration: underline;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":false,"sourceMap":false,"alias":{"../img":"../static/img"}}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-2f96db1e","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js?{"sourceMap":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/views/admin/users.vue
// module id = 1290
// module chunks = 2